import { FieldsFactory } from '../Factory/FieldsFactory';
import { MessageProcessorBase } from './MessageProcessorBase';
import { DirectGoogleAuthResponseMessage } from '@shared/utils/DirectMessages/DirectGoogleAuthResponseMessage';
export class GoogleAuthResponseMessageProcessor extends MessageProcessorBase {
    decode(fieldSet) {
        const message = new DirectGoogleAuthResponseMessage();
        message.Secret2FAKey = fieldSet.GetValue(FieldsFactory.FIELD_SECRET_2FA_KEY);
        message.QRCode = fieldSet.GetValue(FieldsFactory.FIELD_RAW_BYTES);
        message.FileFormat = fieldSet.GetValue(FieldsFactory.FIELD_FILE_FORMAT);
        return [message];
    }
}
